import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithOnlineCourse from '../../app/baseQueryWithOnlineCourse'
import {
    LessonScheduleState,
    UploadLinkState,
} from '../types'


export const lessonScheduleApiSlice = createApi({
    reducerPath: 'lessonScheduleApi',
    baseQuery: baseQueryWithOnlineCourse,
    tagTypes: [
        'LessonSchedule',
    ],
    endpoints: (build) => ({
        fetchScheduleLessons: build.query<LessonScheduleState[], number>({
            query: (courseId) => ({
                url: `lesson/course/${courseId}`,
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({
                            type: 'LessonSchedule' as const,
                            id,
                        })),
                        { type: 'LessonSchedule', id: 'LIST' },
                    ]
                    : [{ type: 'LessonSchedule', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),

        fetchLessonById: build.query<LessonScheduleState, number>({
            query: (id) => ({
                url: `lesson/${id}`,
            }),
            transformResponse: (response: any) => response.data,
            providesTags: (result, error, id) => [{ type: 'LessonSchedule', id }],
        }),

        createScheduleLesson: build.mutation<any, { body: Partial<LessonScheduleState> }>({
            query: ({ body }) => ({
                url: `lesson`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'LessonSchedule', id: 'LIST' }],
        }),

        updateScheduleLesson: build.mutation<any, { id: number; body: Partial<LessonScheduleState> }>({
            query: ({ id, body }) => ({
                url: `lesson/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'LessonSchedule', id },
                { type: 'LessonSchedule', id: 'LIST' },
            ],
        }),

        deleteScheduleLesson: build.mutation<void, number>({
            query: (id) => ({
                url: `lesson/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [
                { type: 'LessonSchedule', id },
                { type: 'LessonSchedule', id: 'LIST' },
            ],
        }),

        fetchUploadLinks: build.query<UploadLinkState[], number>({
            query: (lessonId) => ({
                url: `lesson/${lessonId}/uploadLink`,
            }),
            transformResponse: (response: any) => response.data,
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({
                            type: 'LessonSchedule' as const,
                            id,
                        })),
                        { type: 'LessonSchedule', id: 'LIST' },
                    ]
                    : [{ type: 'LessonSchedule', id: 'LIST' }],
        }),

        createUploadLink: build.mutation<void, { lessonId: number; body: Partial<UploadLinkState> }>({
            query: ({ lessonId, body }) => ({
                url: `lesson/${lessonId}/uploadLink`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'LessonSchedule', id: 'LIST' }],
        }),

        deleteUploadLink: build.mutation<void, { lessonId: number; id: number }>({
            query: ({ lessonId, id }) => ({
                url: `lesson/${lessonId}/uploadLink/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: 'LessonSchedule', id: 'LIST' }],
        }),
    }),
})
